/* Dr. Nature - Sağlık Kategorisi Filter Behavior
   Tıklanan kategori, mevcut sağlık kategorisinin yerine geçer (replace).
   Yaş / Form / Temel İhtiyaç filtreleri korunur (multi-select toggle).
*/
(function () {
  'use strict';

  // Tüm sağlık kategorisi tag handle'ları
  var HEALTH_CATEGORY_HANDLES = [
    'eklem-sagligi', 'bagisiklik-sistemi', 'gunluk-saglik',
    'diskilama-ve-bagirsak-sagligi', 'karaciger-bobrek-pankreas-renal-sagligi',
    'deri-ve-tuy-sagligi', 'agiz-ve-dis-sagligi', 'goz-kulak-sagligi',
    'uriner-saglik', 'kalp-sagligi', 'alerji-ve-kasinti',
    'sakinlestirici-ve-anti-stres', 'mide-sagligi', 'mide-sindirim-sagligi',
    'bakim-urunleri'
  ];

  function isHealthTag(handle) {
    return HEALTH_CATEGORY_HANDLES.indexOf(handle.toLowerCase()) !== -1;
  }

  // Tıklanan link'in href'ini analiz et:
  // - Link mevcut sağlık kategorilerini İÇERİYORSA → "ekle" link'i (Shopify default toggle ON)
  //   → Bizim istediğimiz: mevcut sağlık kategorisini at, yeni'ye geç
  // - Link mevcut sağlık kategorilerini İÇERMİYORSA → "çıkar" link'i (toggle OFF)
  //   → Default davranış (override yok)
  function rewriteUrl(linkHref, currentPath) {
    try {
      var linkUrl = new URL(linkHref, window.location.origin);
      var linkParts = linkUrl.pathname.split('/').filter(Boolean);
      if (linkParts.length < 2 || linkParts[0] !== 'collections') return null;

      var collection = linkParts[1];
      var linkTags = linkParts[2] ? linkParts[2].split('+').map(decodeURIComponent) : [];

      var curParts = currentPath.split('/').filter(Boolean);
      var curTags = curParts[2] ? curParts[2].split('+').map(decodeURIComponent) : [];

      var lc = function (a) { return a.map(function (t) { return t.toLowerCase(); }); };

      // Mevcut sağlık kategorileri
      var currentHealthTags = curTags.filter(function (t) { return isHealthTag(t); });

      // Link sağlık kategorileri
      var linkHealthTags = linkTags.filter(function (t) { return isHealthTag(t); });

      if (currentHealthTags.length === 0) {
        // Mevcut sayfada sağlık kategorisi yok — default davranış (ilk kez seçim)
        return null;
      }

      // Link mevcut sağlık tag'lerini içeriyor mu? (Shopify "ekle" linki)
      var curHealthLc = lc(currentHealthTags);
      var linkHealthLc = lc(linkHealthTags);
      var linkIncludesAllCurrent = currentHealthTags.length > 0 &&
        curHealthLc.every(function (c) { return linkHealthLc.indexOf(c) !== -1; });

      if (!linkIncludesAllCurrent) {
        // Link mevcut'u içermiyor → "çıkar" link'i — Shopify default davranış
        return null;
      }

      // "Ekle" link'i — yeni health tag bul (mevcut'ta olmayan)
      var newHealthTag = null;
      for (var i = 0; i < linkHealthTags.length; i++) {
        if (curHealthLc.indexOf(linkHealthTags[i].toLowerCase()) === -1) {
          newHealthTag = linkHealthTags[i];
          break;
        }
      }

      if (!newHealthTag) {
        // Yeni kategori yok — anlamsız link, default davranış
        return null;
      }

      // Mevcut sağlık kategorilerini at, sadece yeni'yi ekle
      var preservedTags = curTags.filter(function (t) { return !isHealthTag(t); });
      preservedTags.push(newHealthTag);

      var newPath = '/collections/' + collection;
      if (preservedTags.length > 0) {
        newPath += '/' + preservedTags.map(encodeURIComponent).join('+');
      }
      return newPath + linkUrl.search;
    } catch (e) {
      return null;
    }
  }

  function findHealthCategoryWidget() {
    // Filter widget'larını gez, başlığı "Sağlık Kategorisi" olanı bul
    var widgets = document.querySelectorAll('.m-filter--widget');
    for (var i = 0; i < widgets.length; i++) {
      var titleEl = widgets[i].querySelector('.m-filter--widget-title, .m-filter--widget__title');
      if (titleEl && titleEl.textContent.indexOf('Sağlık Kategorisi') !== -1) {
        return widgets[i];
      }
    }
    return null;
  }

  function attachHandlers() {
    var widget = findHealthCategoryWidget();
    if (!widget) return false;

    var links = widget.querySelectorAll('a.m-link, a[href*="/collections/"]');
    var attached = 0;
    links.forEach(function (link) {
      if (link.dataset.dnFilterFix === '1') return;
      link.dataset.dnFilterFix = '1';
      link.addEventListener('click', function (e) {
        var newUrl = rewriteUrl(link.href, window.location.pathname);
        if (newUrl) {
          e.preventDefault();
          e.stopPropagation();
          window.location.href = newUrl;
        }
      }, true);
      attached++;
    });
    return attached > 0;
  }

  function init() {
    if (!attachHandlers()) {
      // Widget henüz render olmamış olabilir, observer ile bekle
      var attempts = 0;
      var iv = setInterval(function () {
        if (attachHandlers() || ++attempts > 20) clearInterval(iv);
      }, 250);
    }
    // AJAX filter güncellemelerinden sonra tekrar bağla
    document.addEventListener('shopify:section:load', attachHandlers);
    document.addEventListener('m:filter:updated', attachHandlers);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
